import React from 'react';

const About = () => {
    return(
        <div className="about section container">
            <div className="about-title title">
                MI Plus Solar
            </div>

            <p className="about-description">
                MI Plus Solar is a group of engineers, communications and business specialists based out of the 
                University of California, Riverside who are developing the MIplus Solar Battery: A technology with the potential to revolutionize solar energy, 
                making it a reliable and affordable energy source for every family and community.
            </p>
        </div>
    )
}

export default About;